import { Hero } from "../components/Hero";
import { ServicesMarquee } from "../components/Marquee";
import { AudienceEntry } from "../components/AudienceEntry";
import { Trust } from "../components/Trust";
import { ServicesOverview } from "../components/Services";
import { BeforeAfter } from "../components/References";
import { Testimonials } from "../components/Testimonials";
import { CtaBand } from "../components/CtaBand";
import { useTitle } from "../components/Reveal";

export default function Home() {
  useTitle("Manfred Berglar · Malermeister seit 1925 · Olpe-Griesemert");
  return (
    <div className="bg-white text-ink overflow-x-clip">
      <div>
        <Hero />
        <ServicesMarquee />
        <AudienceEntry />
        <Trust />
        <ServicesOverview />
        <BeforeAfter />
        <Testimonials />
        <CtaBand
          title="Ihr Projekt beginnt mit einem Gespräch."
          text="Privat, gewerblich oder kommunal – erzählen Sie uns kurz von Ihrem Vorhaben, wir melden uns verbindlich."
        />
      </div>
    </div>
  );
}
